<template>
    <table class="table table-hover no-overflow">
        <thead>
            <tr>
                <th @click="$emit('sort', 'referenceNumber')">
                    Folio de consulta BC
                    <span v-if="privacyStore.sortKey === 'referenceNumber'">
                        <i :class="privacyStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="$emit('sort', 'loanApplication.referenceNumber')">
                    Folio de Solicitud
                    <span v-if="privacyStore.sortKey === 'loanApplication.referenceNumber'">
                        <i :class="privacyStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="$emit('sort', 'loanApplication.prospectus.referenceNumber')">
                    Folio de Prospecto
                    <span v-if="privacyStore.sortKey === 'loanApplication.prospectus.referenceNumber'">
                        <i :class="privacyStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="$emit('sort', 'dateSignature')">
                    Fecha
                    <span v-if="privacyStore.sortKey === 'dateSignature'">
                        <i :class="privacyStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="$emit('sort', 'name')">
                    Nombre
                    <span v-if="privacyStore.sortKey === 'name'">
                        <i :class="privacyStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="$emit('sort', 'loanApplication.prospectus.personTypeId')">
                    Tipo de persona
                    <span v-if="privacyStore.sortKey === 'loanApplication.prospectus.personTypeId'">
                        <i :class="privacyStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="$emit('sort', 'createdAt')">
                    Fecha de creación
                    <span v-if="privacyStore.sortKey === 'createdAt'">
                        <i :class="privacyStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="$emit('sort', 'updatedAt')">
                    Fecha de actualización
                    <span v-if="privacyStore.sortKey === 'updatedAt'">
                        <i :class="privacyStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="$emit('sort', 'status.name')">
                    Estatus
                    <span v-if="privacyStore.sortKey === 'status.name'">
                        <i :class="privacyStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th>Acciones</th>
            </tr>
        </thead>
        <tbody>
            <template v-if="policies.length > 0">
                <tr v-for="policy in policies" :key="policy.id">
                    <td>{{ policy.referenceNumber }}</td>
                    <td>{{ policy.loanApplication?.referenceNumber }}</td>
                    <td>{{ policy.loanApplication?.prospectus?.referenceNumber }}</td>
                    <td>{{ $filters.formatDate(policy.dateSignature) }}</td>
                    <td>{{ getName(policy) }}</td>
                    <td>{{ policy.loanApplication?.prospectus?.personType?.name }}</td>
                    <td>{{ $filters.formatDate(policy.createdAt) }}</td>
                    <td>{{ $filters.formatDate(policy.updatedAt) }}</td>
                    <td>{{ policy.status?.name }}</td>
                    <td>
                        <PrimaryButton class="btn-success" @click="$emit('edit', policy)" data-toggle="modal" data-target="#privacyPolicyModal">
                            <i class="fa fa-edit"></i>
                        </PrimaryButton>
                    </td>
                </tr>
            </template>
            <tr v-else>
                <td colspan="10" style="text-align: center;">{{ $getLocaleMessage('common', 'noDataFound') }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script setup>
import PrimaryButton from '@/Components/PrimaryButton.vue';
import { usePrivacyPolicyStore } from '@/pinia/LoanApplications/Legal/usePrivacyPolicyStore.module';
import { getCurrentInstance } from 'vue';

const props = defineProps({
    policies: {
        type: Array,
        required: true,
        default: () => []
    }
});

/**
 * Abre el modal para editar un registro de aviso de privacidad.
 * Acción por el boton de la tabla
 */
const emit = defineEmits(['sort', 'edit']);

const privacyStore = usePrivacyPolicyStore();

// Acceder a las propiedades globales
const instance = getCurrentInstance();
const $filters = instance?.appContext.config.globalProperties.$filters;

const getName = (item) => {
    if(item.loanApplication.prospectus.personType.id === 1){
        return `${item.loanApplication.prospectus.generalInformation.firstName} ${item.loanApplication.prospectus.generalInformation.lastName} ${item.loanApplication.prospectus.generalInformation.mothersMaidenName}`;
    } else {
        return `${item.loanApplication.prospectus.generalInformation.businessName}`;
    }
}
</script>